<script>
import DownArrowIcon from '@/assets/icons/chevron-down-white.svg';
import { makeid } from '@/utils';

export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },

    title: {
      type: String,
      default: '',
    },

    minWidth: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      isOpen: false,
      randomClass: makeid(10),
      DownArrowIcon,
    };
  },

  mounted() {
    document.body.addEventListener('click', this.clickOutSide, true);
  },

  unmounted() {
    document.body.removeEventListener('click', this.clickOutSide, true);
  },

  methods: {
    onOpenMenu() {
      this.isOpen = !this.isOpen;
    },

    clickOutSide(event) {
      if (!this.isOpen) return;

      const id = `.${this.randomClass}`;
      if (!event.target || !event.target.closest(id.toString())) {
        this.isOpen = false;
      }
    },
  },
};
</script>
<!-- eslint-disable vue/no-undef-components -->
<template>
  <div
    :class="{ [randomClass]: isOpen }"
    class="tw-relative tw-group hover:tw-z-50"
  >
    <div
      class="tw-flex tw-items-center tw-gap-2 tw-text-white tw-cursor-pointer"
      @click="onOpenMenu"
    >
      <div>{{ title }}</div>
      <div>
        <img :src="DownArrowIcon" :class="{ 'tw-rotate-180': isOpen }" />
      </div>
    </div>
    <div
      class="tw-absolute tw-top-full tw-left-0 tw-w-full tw-hidden group-hover:!tw-block tw-bg-white tw-rounded-lg tw-shadow-shadow-2 tw-z-10 tw-overflow-y-auto"
      :class="{ '!tw-block': isOpen }"
      :style="{ minWidth: `${minWidth}px` }"
    >
      <div v-for="(item, i) in options" :key="i" class="">
        <a
          :href="item.link"
          class="tw-text-gray-700 tw-block tw-py-3 tw-px-4 hover:tw-bg-highlight !tw-no-underline"
          @click="isOpen = false"
        >
          {{ item.text }}
        </a>
      </div>
    </div>
  </div>
</template>
